module.exports = __webpack_public_path__ + "static/media/kattis.0a3f6018.png";